import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";

import App from "./App";

import store from "./store/redux";

import { GOOGLE_AUTH_ID } from "./config";

import { AuthContextProvider } from "./store/context/auth-context";
import { ToastProvider } from "./store/context/toast-context";

import "./assets/global.css";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider
      clientId={GOOGLE_AUTH_ID}
    >
      <Provider store={store}>
        <AuthContextProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </AuthContextProvider>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./assets/global.css";
// import App from "./App";

// import store from "./store/redux";
// import { GoogleOAuthProvider } from "@react-oauth/google";
// import { Provider } from "react-redux";
// import { BrowserRouter } from "react-router-dom";
// import { AuthContextProvider } from "./store/context/auth-context";
// import { GOOGLE_AUTH_ID } from "./config";
// import { ToastProvider } from "./store/context/toast-context";
// // import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <GoogleOAuthProvider clientId={GOOGLE_AUTH_ID}>
//     <AuthContextProvider>
//       <Provider store={store}>
//         <ToastProvider>
//           <BrowserRouter>
//             <App />
//           </BrowserRouter>
//         </ToastProvider>
//       </Provider>
//     </AuthContextProvider>
//   </GoogleOAuthProvider>
// );

// // reportWebVitals();
